import { Button } from "@sellar-io/components";
import {
  DialogNavigation,
  DialogContent,
} from "../../../../../components/modal/Dialog";
import { Alert } from "../../../../../components/alert/Alert";
import { useNavigate } from "react-router";
import * as ROUTES from "../../../../../constants/routes";

export default function NoBasePriceListContent({
  onDismiss,
}: {
  onDismiss: () => void;
}) {
  const navigate = useNavigate();

  return (
    <>
      <DialogNavigation
        title="Cannot create a new product"
        description="You need to input a base price list before you can set up any new products"
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={() => onDismiss()}
      />
      <DialogContent>
        <Alert
          type="information"
          title="Go to Pricing to input your base price list"
          message="Your base price list is the starting point from which you can derive custom pricing for your products"
        >
          <Button
            color="secondary"
            className="mt-4 border-blue-800 bg-transparent text-blue-800 hover:bg-blue-200"
            onClick={() => navigate(ROUTES.PRICE_LISTS)}
          >
            Go to pricing
          </Button>
        </Alert>
      </DialogContent>
    </>
  );
}
